import moment from 'moment';
import { DateHelper } from '@/date-helper';

export function calculateRemainingDays(campaign) {
  console.assert(campaign['finished_at']);

  const todayWithoutTimes = moment(new Date()).format('YYYY-MM-DD');
  const daysDiff = DateHelper.count(
    campaign['finished_at'],
    todayWithoutTimes,
    'days'
  );
  return daysDiff >= 0 ? daysDiff + 1 : 0;
}

export function isTargetDonor(campaign) {
  return !!campaign['target_donors'] && !campaign['target_amount'];
}

export function getCurrentValue(campaign) {
  return isTargetDonor(campaign)
    ? campaign['total_donors']
    : campaign['total_donation_amount'];
}

export function getTargetValue(campaign) {
  return isTargetDonor(campaign)
    ? campaign['target_donors']
    : campaign['target_amount'];
}

export function getTargetValueStretch1(campaign) {
  return isTargetDonor(campaign)
    ? campaign['target_donors_stretch_1']
    : campaign['target_amount_stretch_1'];
}

export function getTargetValueStretch2(campaign) {
  return isTargetDonor(campaign)
    ? campaign['target_donors_stretch_2']
    : campaign['target_amount_stretch_2'];
}
